import { Toast } from "primereact/toast";
import { useContext, useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { APP_BASE_URL, EmployeeStatusDropdown, percentageOptions } from "../../appconfig/Settings";
import axiosInstance from "../../config/axiosInstance";

import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
  provinces,
} from "../../appconfig/Settings";
import { EmployeeListColumns } from "../../appconfig/DatatableSetting";
import { deleteData, postAllData, postDataByID, updateData } from "../../service/ProductService";
import {
  DELETE_EMPLOYEE,
  GET_EMPLOYEE_LIST,
  SAVE_EMPLOYEE_DATA,
  UPDATE_EMPLOYEE_ACTIVE_STATUS,
  UPDATE_EMPLOYEE_DATA,
} from "../../config/ApiConstant";
import { addressTemplate, amountTemplate, dateTemplate, nameTemplate } from "../../appconfig/TemplateFieldSetting";
import { validateEmployeeForm, validateEmployeStatusDate } from "../../config/Validate";
import { Link } from "react-router-dom";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Tag } from "primereact/tag";
import moment from "moment";
import { InputNumber } from "primereact/inputnumber";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { InputSwitch } from "primereact/inputswitch";
import { Badge } from "primereact/badge";
import ViewSinNumber from "../../components/ViewSinNumber/ViewSinNumber";

const ManageEmployee = () => {
  document.title = "Employee | Nexawage Payroll";
  const toast = useRef<any>(null);
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState<any>([]);
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false);
  const [addDeleteEmployeeDialog, setAddDeleteEmployeeDialog] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<any>(null);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [globleEmployeeData, setGlobalEmployeeData] = useState<any>({
    tax_deduction: "100",
  });

  // employee active status
  // review status
  const [activeEmployeeId, setActiveEmployeeId] = useState<any>(null);

  // active status dialog
  const [activeEmployeeDialog, setActiveEmployeeDialog] = useState<boolean>(false);

  // employee status
  const [employeeStatus, setEmployeeStatus] = useState<any>('Active');

  // employee dropdown status
  const [selectedDropdownStatus, setSelectedDropdownStatus] = useState<any>(null);
  const [currentEmpStatus, setCurrentEmpStatus] = useState<any>(null);

  // employee status update date
  const [empStatusChangeDate, setEmpStatusChangeDate] = useState<any>(new Date());

  // roe issuer name
  const [roeIssuerName, setRoeIssuerName] = useState<any>(null);

  // payroll reference number
  const [payrollRefNo, setPayrollRefNo] = useState<any>(null);

  // who to contact for further information
  const [contactPerson, setContactPerson] = useState<any>("User");

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    email: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    joining_date: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
    emp_status: {
      operator: FilterOperator.OR,
      constraints: [{ value: 'Active', matchMode: FilterMatchMode.EQUALS }],
    },
    phone: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  // Calculate the minimum date
  const today = new Date();
  const maxDate = new Date();
  maxDate.setFullYear(today.getFullYear() - 14);

  // useefect for get user list
  useEffect(() => {
    getEmployeeList();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // get employee list api
  const getEmployeeList = async () => {
    try {
      const response = await axiosInstance(APP_BASE_URL + GET_EMPLOYEE_LIST + "?type=Employee");
      const data = response?.data?.data;

      // normalise date to convert into data object instead of string
      const normalise = response?.data?.data?.map((item: any) => ({
        ...item,

        joining_date: item.joining_date ? new Date(item.joining_date.substring(0, 10) + "T00:00:00") : null,

        // searchable name for globle filter
        first_name_search: item.first_name ? item?.first_name : "",
        last_name_search: item.last_name ? item?.last_name : "",

        // searchable joining date on globle filter
        joining_date_search: item.joining_date ? moment(item.joining_date).format("DD MMM YYYY") : "",
      }));

      if (data) {
        setEmployeeList(normalise);
        setPageLoad(true);
      } else {
        setEmployeeList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // clear all filter
  const clearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // global search filter on change
  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <span className="block mr-2 p-input-icon-left">
      <i className="pi pi-search" />
      {/* <InputText type="search" value={globalFilter || ""} onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." /> */}
      <InputText type="search" value={globalFilter || ""} onChange={onGlobalFilterChange} placeholder="Search..." />
    </span>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <Button icon="pi pi-filter-slash" label="Clear" onClick={clearAll} className="mr-2 p-button-outlined common-p-outline-button" />
      {userData?.roles?.role_name === "Client" && (
        <Button className="ml-1 common-primary-button" icon="pi pi-plus" label="Add Employee Data" onClick={() => addEditDialog()} />
      )}
    </>
  );

  // delete confirmation modal
  const confirmDelete = (deleteID: any) => {
    setDeleteId(deleteID);
    setDeleteDialog(true);
  };

  // delete employee api call
  const deleteEmployee = async () => {
    try {
      setSubmitLoading(true);
      const response = await deleteData(DELETE_EMPLOYEE, deleteId);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: response.message,
        });
        hideDeleteDialog();
        getEmployeeList();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setSubmitLoading(false);
    }
  };

  // hide delete modal
  const hideDeleteDialog = () => {
    setDeleteDialog(false);
    setDeleteId(null);
  };

  // add edit employee dialog
  const addEditDialog = async (rowData: any = null) => {
    if (rowData) {
      setGlobalEmployeeData({ tax_deduction: "100", ...rowData });
      setIsEdit(true);
    } else {
      setGlobalEmployeeData({ tax_deduction: "100" });
      setIsEdit(false);
    }

    setErrors({});
    setAddDeleteEmployeeDialog(true);
  };

  // hide add & edit employee modal
  const hideAddEditEmployeeDialog = () => {
    setAddDeleteEmployeeDialog(false);
    setSubmitLoading(false);
  };

  // employee input change
  const onInputChange = (e: any, name: string) => {
    let val;
    if (name === "ei_exempt" || name === "cpp_exempt" || name === "vacation_hold" || name === "no_vacation_payout" || name === "is_salary") {
      val = e.checked ? true : false;
    } else if ((name === "joining_date" && val) || (name === "date_of_birth" && val)) {
      val = moment(val).format("YYYY-MM-DD");
    } else {
      val = e?.target?.value ?? e?.value;
    }

    // format postal code: add space after 3 characters
    if (name === "postal_code" && val) {
      // remove all spaces first
      val = val.replace(/\s+/g, "").toUpperCase();
      // insert space after 3 characters if length > 3
      if (val.length > 3) {
        val = val.slice(0, 3) + " " + val.slice(3);
      }
    }

    setGlobalEmployeeData({ ...globleEmployeeData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // add & update employee api call
  const submitEmployeeForm = async () => {
    const { isError, errors } = validateEmployeeForm(globleEmployeeData, isEdit);
    setErrors(errors);
    if (isError) return;

    setSubmitLoading(true);
    try {
      const payload = {
        client_head: userData?.id,
        // id: globleEmployeeData?.id,
        first_name: globleEmployeeData?.first_name,
        last_name: globleEmployeeData?.last_name,
        email: globleEmployeeData?.email,
        phone: globleEmployeeData?.phone,
        occupation: globleEmployeeData?.occupation,
        sin_number: globleEmployeeData?.sin_number,
        wage: globleEmployeeData?.wage,
        ...(globleEmployeeData?.is_salary === false || globleEmployeeData?.is_salary === undefined) && { wage_night: globleEmployeeData?.wage_night },
        tax_deduction: globleEmployeeData?.tax_deduction,
        joining_date: globleEmployeeData?.joining_date ? moment(globleEmployeeData?.joining_date).format("YYYY-MM-DD") : null,
        address: globleEmployeeData?.address,
        date_of_birth: globleEmployeeData?.date_of_birth ? moment(globleEmployeeData?.date_of_birth).format("YYYY-MM-DD") : null,
        ei_exempt: globleEmployeeData?.ei_exempt ? 1 : 0,
        cpp_exempt: globleEmployeeData?.cpp_exempt ? 1 : 0,
        vaccation_payout: globleEmployeeData.vaccation_payout,
        vacation_hold: globleEmployeeData?.vacation_hold ? 1 : 0,
        no_vacation_payout: globleEmployeeData?.no_vacation_payout ? 1 : 0,
        is_salary: globleEmployeeData?.is_salary ? 1 : 0,
        // pay_stat_holiday: globleEmployeeData?.pay_stat_holiday ? 1 : 0,
        province: globleEmployeeData?.province,
        postal_code: globleEmployeeData?.postal_code,
        city: globleEmployeeData?.city,
        type: "Employee",
      };

      const response = isEdit
        ? await updateData(UPDATE_EMPLOYEE_DATA, globleEmployeeData?.id, payload)
        : await postAllData(SAVE_EMPLOYEE_DATA, payload);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideAddEditEmployeeDialog();
        getEmployeeList();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // action body template
  const actionBodyTemplate = (rowData: any) =>
    rowData ? (
      <div className="action">
        <Button
          icon="pi pi-ellipsis-v"
          tooltip="Change Status"
          className="common-primary-button mr-2"
          tooltipOptions={{ position: "bottom" }}
          onClick={(e) => onStatusChange(rowData)}
        />
        <Button
          icon="pi pi-pencil"
          tooltip="Edit"
          className="common-edit-btn"
          tooltipOptions={{ position: "bottom" }}
          onClick={() => addEditDialog(rowData)}
        />
        <Button
          icon="pi pi-trash"
          tooltipOptions={{ position: "bottom" }}
          className="ml-2 p-button-danger common-delete-btn"
          tooltip="Delete"
          onClick={() => confirmDelete(rowData.id)}
        />
      </div>
    ) : (
      "-"
    );

  //  employee detail template
  const employeeDetailTemplate = (rowData: any) => {
    return (
      <Link style={{ textDecoration: "underline", color: "blue" }} to={`/employee/${btoa(rowData.id)}`}>
        {rowData.unique_id}
      </Link>
    );
  };

  // status active employee api call

  const approveStatusUpdate = async () => {
    try {
      const isActive = selectedDropdownStatus === "Active";

      // Validate only when date field is visible

      const { isError, errors } = validateEmployeStatusDate(empStatusChangeDate, selectedDropdownStatus, roeIssuerName, payrollRefNo);

      setErrors(errors);
      if (isError) return;

      setSubmitLoading(true);

      const payload = {
        emp_status: selectedDropdownStatus,
        ...(isActive
          ? { rejoining_date: moment(empStatusChangeDate).format("YYYY-MM-DD") }
          : {
              emp_status_date: moment(empStatusChangeDate).format("YYYY-MM-DD"),
              issuer_name: roeIssuerName,
              payroll_ref_no: payrollRefNo,
              contact_person: contactPerson,
            }),
      };

      //call api
      const response = await updateData(UPDATE_EMPLOYEE_ACTIVE_STATUS, activeEmployeeId, payload);

      if (response) {
        setActiveEmployeeDialog(false);
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response?.message,
        });
        setPageLoad(true);
        setSubmitLoading(false);
        setEmpStatusChangeDate(new Date());
        setRoeIssuerName(null);
        setPayrollRefNo(null);
        setContactPerson("User");
        getEmployeeList();
      }
    } catch (error: any) {
      setPageLoad(true);
      setSubmitLoading(false);
      setActiveEmployeeDialog(false);
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // close employee status dialog
  // const hideActiveDialog = () => {
  //   setActiveEmployeeDialog(false);
  //   setActiveEmployeeId(null);
  // };
  const hideActiveDialog = () => {
    setActiveEmployeeDialog(false);
    setActiveEmployeeId(null);
    setSelectedDropdownStatus(null);
    setEmpStatusChangeDate(new Date());
    setRoeIssuerName(null);
    setPayrollRefNo(null);
    setContactPerson("User");
  };

  // on status change
  // const onStatusChange = (rowData: any, e: any) => {
  //   setActiveEmployeeId(rowData?.id);
  //   setSelectedDropdownStatus(rowData?.emp_status);
  //   setActiveEmployeeDialog(true);
  // };

  // on status change
  const onStatusChange = (rowData: any) => {
    setActiveEmployeeId(rowData.id);
    setSelectedDropdownStatus(rowData.emp_status);
    setCurrentEmpStatus(rowData.emp_status);

    if (rowData?.employee_roe) {
      setRoeIssuerName(rowData?.employee_roe?.issuer_name);
      setPayrollRefNo(rowData?.employee_roe?.payroll_ref_no);
    }

    //Use employee’s status date if available
    if (rowData?.emp_status_date) {
      const parsedDate = moment(rowData.emp_status_date, "YYYY-MM-DD").toDate();
      setEmpStatusChangeDate(parsedDate);
    } else {
      setEmpStatusChangeDate(new Date());
    }

    setActiveEmployeeDialog(true);
  };

  // active status employee Template
  const activeEmployeeStatusTemplate = (rowData: any) => {
    let statusClass: any =
      rowData?.emp_status === "Terminated"
        ? "danger"
        : rowData?.emp_status === "Active"
          ? "success"
          : rowData?.emp_status === "Paid leave of absence"
            ? "contrast"
            : rowData?.emp_status === "Unpaid leave of absence"
              ? "info"
              : rowData?.emp_status === "Not on payroll"
                ? "warning"
                : rowData?.emp_status === "Deceased"
                  ? "secondary"
                  : "";
    return (
      <div className="action flex flex-column align-items-center">
        {rowData?.emp_status ? <Badge severity={statusClass} value={rowData.emp_status} style={{ width: "fit-content" }}></Badge> : "-"}
      </div>
    );
  };


  const salaryTemplate = (rowData: any) => {
    return (
      <div className="actions">
        {rowData?.is_salary ? <Badge severity="success" value="Yes" style={{ width: "fit-content" }}></Badge> : <Badge severity="danger" value="No" style={{ width: "fit-content" }}></Badge>}
      </div>
    );
  };

  // sin Number template
  const sinNumberTemplate = (rowData: any) => {
    return (
      <div className="actions">
        <ViewSinNumber label="SIN Number" value={rowData?.sin_number} />
      </div>
    );
  };

  // active employee status template
  const employeeStatusFilterTemplate = (options: any) => {
    return (
      <Dropdown
        // filter
        value={employeeStatus}
        onChange={(e: any) => {
          setEmployeeStatus(e.value);
          options.filterCallback(e.value ? e.value : null, options.index);
        }}
        options={EmployeeStatusDropdown}
        optionLabel="name"
        placeholder="Status"
        className="order-drp"
      ></Dropdown>
    );
  };

  // date filter template
  const dateFilterTemplate = (options: any) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.value)}
        dateFormat="dd/mm/yy"
        placeholder="Select Date"
        showIcon
      />
    );
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Manage Employee" pageName="Employee List" pageTitle="Employee List" />
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />
            {pageLoad ? (
              <DataTable
                value={employeeList}
                showGridlines
                dataKey="id"
                stripedRows
                globalFilter={globalFilter}
                responsiveLayout={"scroll"}
                rows={defaultRowOptions}
                paginator={employeeList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Employee"}
                emptyMessage="No Employee Found"
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                globalFilterFields={[
                  "unique_id",
                  "wage",
                  "emp_status",
                  "first_name",
                  "email",
                  "phone",
                  "joining_date_search",
                  "sin_number",
                  "province",
                ]}
                removableSort
              >
                {EmployeeListColumns.map((col, i) => {
                  if (col.field === "name") {
                    return <Column key={col.field} field={col.field} header={col.header} body={nameTemplate} />;
                  } else if (col.field === "action") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else if (col.field === "email") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                        filter
                        filterPlaceholder={"Search by " + col.header}
                        filterField={col.field}
                      />
                    );
                  } else if (col.field === "phone") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                        filter
                        filterPlaceholder={"Search by " + col.header}
                        filterField={col.field}
                      />
                    );
                  } else if (col.field === "joining_date") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={dateTemplate}
                        sortable
                        filterPlaceholder={col.header}
                        dataType="date"
                        filter
                        filterElement={dateFilterTemplate}
                      />
                    );
                  } else if (col.field === "address") {
                    return <Column key={col.field} field={col.field} header={col.header} body={addressTemplate} />;
                  } else if (col.field === "wage") {
                    return <Column key={col.field} field={col.field} header={col.header} body={amountTemplate} />;
                  } else if (col.field === "sin_number") {
                    return <Column key={col.field} field={col.field} header={col.header} body={sinNumberTemplate} />;
                  } else if (col.field === "emp_status") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={activeEmployeeStatusTemplate}
                        filter
                        filterField="emp_status"
                        filterElement={employeeStatusFilterTemplate}
                      />
                    );
                  }
                  else if (col.field === "is_salary") {
                    return <Column key={col.field} field={col.field} header={col.header} body={salaryTemplate} />;
                  }
                  else if (col.field === "unique_id") {
                    return <Column key={col.field} field={col.field} header={col.header} body={employeeDetailTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {EmployeeListColumns.map((col) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>
      {/* Add/Edit Dialog */}
      <Dialog
        visible={addDeleteEmployeeDialog}
        style={{ width: "800px" }}
        className="mx-3 lg:mx-0"
        draggable={false}
        header={isEdit ? "Edit Employee" : "Add Employee"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideAddEditEmployeeDialog} />
            <Button label="Submit" icon="pi pi-check" className="common-primary-button" onClick={submitEmployeeForm} loading={submitLoading} />
          </div>
        }
        onHide={hideAddEditEmployeeDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* First Name */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">First Name *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.first_name || ""}
                name="first_name"
                autoComplete="off"
                placeholder="Enter First Name"
                onChange={(e) => onInputChange(e, "first_name")}
                className={errors["first_name"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["first_name"]}</small>
          </div>

          {/* Last Name */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">Last Name *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.last_name || ""}
                name="last_name"
                autoComplete="off"
                placeholder="Enter Last Name"
                onChange={(e) => onInputChange(e, "last_name")}
                className={errors["last_name"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["last_name"]}</small>
          </div>
          {/* Email */}
          <div className="field col-12 md:col-6">
            <label htmlFor="email">Email *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.email || ""}
                name="email"
                autoComplete="off"
                placeholder="Enter Email"
                onChange={(e) => onInputChange(e, "email")}
                className={errors["email"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["email"]}</small>
          </div>
          {/* Phone */}
          <div className="field col-12 md:col-6">
            <label htmlFor="phone">Phone *</label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <span className="font-bold p-inputgroup-addon">+1</span>
              <InputText
                value={globleEmployeeData.phone || ""}
                name="phone"
                autoComplete="off"
                placeholder="Enter Phone Number"
                onChange={(e) => onInputChange(e, "phone")}
                className={errors["phone"] && "p-invalid"}
                keyfilter="pint"
                maxLength={10}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["phone"]}</small>
          </div>

          {/* Occupation */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">Occupation </label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.occupation || ""}
                name="occupation"
                autoComplete="off"
                placeholder="Enter Occupation"
                onChange={(e) => onInputChange(e, "occupation")}
                className={errors["occupation"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["occupation"]}</small>
          </div>

          {/* Joining Date */}
          <div className="field col-12 md:col-6">
            <label htmlFor="date">Joining Date *</label>
            <div className="input-effect-div">
              <Calendar
                value={globleEmployeeData.joining_date ? moment(globleEmployeeData.joining_date, "YYYY-MM-DD").toDate() : null}
                dateFormat="dd/mm/yy"
                placeholder="Enter Joining Date"
                onChange={(e) => onInputChange(e, "joining_date")}
                showIcon
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["joining_date"]}</small>
          </div>
          <div className="flex flex-wrap gap-3 justify-content-between field align-items-center col-12">
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption4"
                name="is_salary"
                checked={globleEmployeeData.is_salary === true}
                onChange={(e) => onInputChange(e, "is_salary")}
              />
              <label htmlFor="checkOption2">Is Salary</label>
            </div>
          </div>

          <>
            <div className="field col-12 md:col-6">
              <label htmlFor="wage">{globleEmployeeData.is_salary === true ? "Salary Amount *" : "Wage *"}</label>
              <form autoComplete="off">
                <div className="flex-1 input-effect-div p-inputgroup">
                  <span className="font-bold p-inputgroup-addon">$</span>
                  <InputNumber
                    value={globleEmployeeData.wage}
                    name="wage"
                    onChange={(e) => onInputChange(e, "wage")}
                    placeholder={globleEmployeeData.is_salary === true ? "Enter Salary Amount" : "Enter Wage"}
                    className={errors["wage"] && "p-invalid"}
                    // minFractionDigits={2}
                    maxFractionDigits={2}
                    mode="decimal"
                    useGrouping={false} />
                  {/* <span className="focus-bg"></span> */}
                </div>
              </form>

              <small className="p-invalid-txt">{errors["wage"]}</small>
            </div>
            {(globleEmployeeData.is_salary === false || globleEmployeeData.is_salary === undefined) && (

              <div className="field col-12 md:col-6">
                <label htmlFor="wage_night">Wage 2 </label>
                <form autoComplete="off">
                  <div className="flex-1 input-effect-div p-inputgroup">
                    <span className="font-bold p-inputgroup-addon">$</span>
                    <InputNumber
                      value={globleEmployeeData.wage_night}
                      name="wage_night"
                      onChange={(e) => onInputChange(e, "wage_night")}
                      placeholder="Enter Wage 2"
                      className={errors["wage_night"] && "p-invalid"}
                      // minFractionDigits={2}
                      maxFractionDigits={2}
                      mode="decimal"
                      useGrouping={false} />
                    {/* <span className="focus-bg"></span> */}
                  </div>
                </form>

                <small className="p-invalid-txt">{errors["wage_night"]}</small>
              </div>
            )}
          </>
          {/* Date of Birth */}
          <div className="field col-12 md:col-6">
            <label htmlFor="date">Date of Birth *</label>
            <div className="input-effect-div">
              <Calendar
                value={globleEmployeeData.date_of_birth ? moment(globleEmployeeData.date_of_birth, "YYYY-MM-DD").toDate() : null}
                dateFormat="dd/mm/yy"
                placeholder="Enter Date Of Birth"
                maxDate={maxDate}
                onChange={(e) => onInputChange(e, "date_of_birth")}
                showIcon
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["date_of_birth"]}</small>
          </div>

          {/* SIN number */}
          <div className="field col-12 md:col-6">
            <label htmlFor="number">SIN Number *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.sin_number || ""}
                name="sin_number"
                autoComplete="off"
                placeholder="Enter SIN Number"
                onChange={(e) => onInputChange(e, "sin_number")}
                className={errors["sin_number"] && "p-invalid"}
                keyfilter="pint"
                maxLength={9}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["sin_number"]}</small>
          </div>

          {/* CheckBox */}

          <div className="flex flex-wrap gap-2 justify-content-between field align-items-center col-12 md:col-6">
            {/* CheckBox */}
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption3"
                name="vacation_hold"
                checked={globleEmployeeData.vacation_hold === true}
                onChange={(e) => onInputChange(e, "vacation_hold")}
              />
              <label htmlFor="checkOption3">Vacation Payout On Hold</label>
            </div>

            {/* CheckBox */}
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption4"
                name="no_vacation_payout"
                checked={globleEmployeeData.no_vacation_payout === true}
                onChange={(e) => onInputChange(e, "no_vacation_payout")}
              />
              <label htmlFor="checkOption2">No Vacation Payout</label>
            </div>
          </div>

          <div className="flex flex-wrap gap-3 justify-content-between field align-items-center col-12 md:col-6">
            {/* CheckBox */}
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption1"
                name="ei_exempt"
                checked={globleEmployeeData.ei_exempt === true}
                onChange={(e) => onInputChange(e, "ei_exempt")}
              />
              <label htmlFor="checkOption1">EI Exempt</label>
            </div>

            {/* CheckBox */}
            <div className="mb-0 field-checkbox">
              <Checkbox
                inputId="checkOption2"
                name="cpp_exempt"
                checked={globleEmployeeData.cpp_exempt === true}
                onChange={(e) => onInputChange(e, "cpp_exempt")}
              />
              <label htmlFor="checkOption2">CPP Exempt</label>
            </div>

            {/* stat holiday */}
            <div className="">
              {/* <div className="mb-0 field-checkbox">
                <Checkbox
                  inputId="statholiday"
                  name="pay_stat_holiday"
                  checked={globleEmployeeData.pay_stat_holiday === true}
                  onChange={(e) => onInputChange(e, "pay_stat_holiday")}
                />
                <label htmlFor="statholiday">Pay Stat Holiday</label>
              </div> */}
            </div>
          </div>
          {/* vacation payout*/}
          <div className="field col-12 md:col-6">
            <label htmlFor="vaccation_payout">Vacation Payout*</label>
            <form autoComplete="off">
              <div className="flex-1 input-effect-div p-inputgroup">
                <InputNumber
                  value={globleEmployeeData.vaccation_payout}
                  name="vaccation_payout"
                  onChange={(e) => onInputChange(e, "vaccation_payout")}
                  placeholder="Enter Vacation Payout"
                  className={errors["vaccation_payout"] && "p-invalid"}
                  // minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                  useGrouping={false}
                />

                <span className="font-bold p-inputgroup-addon">%</span>
                {/* <span className="focus-bg"></span> */}
              </div>
            </form>
            <small className="p-invalid-txt">{errors["vaccation_payout"]}</small>
          </div>

          {/* Tax deduction */}
          <div className="field col-12 md:col-6">
            <label htmlFor="wage">Tax Deduction*</label>
            <form autoComplete="off">
              <div className="flex-1 input-effect-div p-inputgroup">
                <Dropdown
                  value={globleEmployeeData.tax_deduction || ""}
                  onChange={(e) => onInputChange(e, "tax_deduction")}
                  options={percentageOptions}
                  optionLabel="name"
                  optionValue="value"
                  id={"tax_deduction"}
                  placeholder="Select Tax Percentage"
                  className="order-drp"
                />
                <span className="font-bold p-inputgroup-addon">%</span>
                {/* <span className="focus-bg"></span> */}
              </div>
            </form>

            <small className="p-invalid-txt">{errors["tax_deduction"]}</small>
          </div>

          {/* provinces */}
          <div className="field md:col-6 col-12">
            <label htmlFor="province">Select Province *</label>
            <Dropdown
              value={globleEmployeeData.province || ""}
              onChange={(e) => onInputChange(e, "province")}
              options={provinces}
              placeholder="Select Province"
              className={errors["province"] ? "p-invalid" : ""}
            />
            <small className="p-invalid-txt">{errors["province"]}</small>
          </div>

          {/* City */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">City *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.city || ""}
                name="city"
                autoComplete="off"
                placeholder="Enter City"
                onChange={(e) => onInputChange(e, "city")}
                className={errors["city"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["city"]}</small>
          </div>

          {/* Postal Code */}
          <div className="field col-12 md:col-6">
            <label htmlFor="postal_code">Postal Code *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.postal_code || ""}
                name="postal_code"
                autoComplete="off"
                placeholder="Enter Postal Code"
                onChange={(e) => onInputChange(e, "postal_code")}
                className={errors["postal_code"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["postal_code"]}</small>
          </div>

          {/* Street Address */}
          <div className="field col-12 md:col-6">
            <label htmlFor="address"> Street Address *</label>
            <div className="input-effect-div">
              <InputText
                value={globleEmployeeData.address || ""}
                name="address"
                autoComplete="off"
                maxLength={30}
                placeholder="Enter Street Address"
                onChange={(e) => onInputChange(e, "address")}
                className={errors["address"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["address"]}</small>
          </div>
        </div>
      </Dialog >
      {/* Delete Dialog */}
      < Dialog
        visible={deleteDialog}
        header="Delete Employee"
        draggable={false}
        className="mx-3 lg:mx-0"
        modal
        footer={
          < div className="flex pt-2 align-items-center justify-content-end" >
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideDeleteDialog} />
            <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteEmployee} loading={submitLoading} />
          </div >
        }
        onHide={hideDeleteDialog}
      >
        <div className="flex align-items-center justify-content-start">
          <i className="mr-3 pi pi-exclamation-triangle delete-triangle" style={{ fontSize: "2rem" }} />
          <span className="delete-dialog-note">Are you sure you want to delete this Employee?</span>
        </div>
      </Dialog >

      {/*  */}
      {/* employee active dialog */}
      <Dialog
        visible={activeEmployeeDialog}
        style={{ width: "450px" }}
        className="mx-3 lg:mx-0"
        header="Status Update"
        draggable={false}
        modal
        footer={
          <>
            <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={hideActiveDialog} />
            <Button label="Confirm" icon="pi pi-check" className="common-primary-button" onClick={approveStatusUpdate} loading={submitLoading} />
          </>
        }
        onHide={hideActiveDialog}
      >
        <div className="">
          <p>
            <span style={{ fontWeight: "600", fontSize: "18px" }}>Note: </span> On Termination Employee ROE will be generated.
          </p>
          {
            <div className="grid p-fluid formgrid">
              <div className="field col-12 ">
                <label htmlFor="status">
                  Select Status <span className="required">*</span>
                </label>
                <Dropdown
                  value={selectedDropdownStatus}
                  onChange={(e) => setSelectedDropdownStatus(e.value)}
                  options={EmployeeStatusDropdown}
                  optionLabel="name"
                  optionValue="value"
                  placeholder="Select Status"
                />
              </div>

              {selectedDropdownStatus && !(selectedDropdownStatus === "Active" && currentEmpStatus === "Active") && (
                <div className="field col-12">
                  <label htmlFor="date">{selectedDropdownStatus === "Active" ? "Rejoining Date *" : "Select Date *"}</label>
                  <div className="input-effect-div">
                    <Calendar
                      value={empStatusChangeDate}
                      dateFormat="dd/mm/yy"
                      placeholder="Select Date"
                      onChange={(e) => setEmpStatusChangeDate(e.value)}
                      showIcon
                    />
                    <span className="focus-bg"></span>
                  </div>
                  <small className="p-invalid-txt">{errors["emp_status_date"]}</small>
                </div>
              )}

              {selectedDropdownStatus && selectedDropdownStatus !== "Active" && (
                <div className="field col-12 ">
                  <label htmlFor="name">ROE Issuer Name *</label>
                  <div className="input-effect-div">
                    <InputText
                      value={roeIssuerName}
                      name="issuer_name"
                      autoComplete="off"
                      placeholder="Enter ROE Issuer name"
                      onChange={(e) => setRoeIssuerName(e?.target?.value)}
                      className={errors["issuer_name"] && "p-invalid"}
                    />
                    <span className="focus-bg"></span>
                  </div>
                  <small className="p-invalid-txt">{errors["issuer_name"]}</small>
                </div>
              )}

              {selectedDropdownStatus && selectedDropdownStatus !== "Active" && (
                <div className="field col-12 ">
                  <label htmlFor="contact_person">Who to contact for further information?</label>
                  <div className="flex gap-4 mt-2">
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="contact_person_user"
                        name="contact_person"
                        value="User"
                        onChange={(e) => setContactPerson(e.value)}
                        checked={contactPerson === "User"}
                      />
                      <label htmlFor="contact_person_user" className="ml-2">
                        User
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="contact_person_client"
                        name="contact_person"
                        value="Client"
                        onChange={(e) => setContactPerson(e.value)}
                        checked={contactPerson === "Client"}
                      />
                      <label htmlFor="contact_person_client" className="ml-2">
                        Client
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {selectedDropdownStatus && selectedDropdownStatus !== "Active" && (
                <div className="field col-12 ">
                  <label htmlFor="payroll_ref_no">Payroll Reference Number *</label>
                  <div className="input-effect-div">
                    <InputText
                      value={payrollRefNo}
                      name="payroll_ref_no"
                      autoComplete="off"
                      placeholder="Enter Payroll Reference Number"
                      onChange={(e) => setPayrollRefNo(e?.target?.value)}
                      className={errors["payroll_ref_no"] && "p-invalid"}
                    />
                    <span className="focus-bg"></span>
                  </div>
                  <small className="p-invalid-txt">{errors["payroll_ref_no"]}</small>
                </div>
              )}
            </div>
          }
        </div>
      </Dialog>
    </>
  );
};
export default ManageEmployee;
